// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__1C7Nn","icon":"SearchBar_icon__2zQ-e","inputWrapper":"SearchBar_inputWrapper__34cXV","input":"SearchBar_input__2Emge"};